import Button from 'src/components/Button';
import { IconEmpty, IconPlus } from 'src/icons';

type EmptyCoordinationStateProps = {
  onAddActivity: () => void;
};

export const EmptyCoordinationState = ({ onAddActivity }: EmptyCoordinationStateProps) => {
  return (
    <>
      <div className="flex h-full w-full flex-col items-center ">
        <div className="flex justify-center text-center">
          <div className="h-10 w-10 rounded-[200px] bg-secondary-900">
            <IconEmpty className="m-2 h-6 w-6 text-secondary-300" />
          </div>
        </div>
        <p className="mt-4 text-center text-neutral-100 typography-heading-md">
          No coordination activities recorded.
        </p>
        <p className="mt-4 text-neutral-300 typography-body-md">
          Log a minimum of 3 activities now.
        </p>
        <div className="mt-8">
          <Button preset="secondary" Icon={IconPlus} onClick={onAddActivity}>
            Add Activity
          </Button>
        </div>
      </div>
    </>
  );
};
